"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultSectionId = exports.OffersSectionSchema = void 0;
const mongoose_1 = require("mongoose");
exports.OffersSectionSchema = new mongoose_1.Schema({
    id: {
        type: Number,
        unique: true,
        required: true
    },
    title: Object,
    button: Object
});
var DefaultSectionId;
(function (DefaultSectionId) {
    DefaultSectionId[DefaultSectionId["GAMBLING_MAIN"] = 0] = "GAMBLING_MAIN";
    DefaultSectionId[DefaultSectionId["BETTING_MAIN"] = 1] = "BETTING_MAIN";
    DefaultSectionId[DefaultSectionId["GAMBLING_PLAYED"] = 2] = "GAMBLING_PLAYED";
    DefaultSectionId[DefaultSectionId["BETTING_PLAYED"] = 3] = "BETTING_PLAYED";
})(DefaultSectionId = exports.DefaultSectionId || (exports.DefaultSectionId = {}));
